module.exports = __webpack_public_path__ + "img/W-S64.0b875b22.jpg";